export const GET_HOTELS = 'GET_HOTELS';
export const GET_HOTEL_PRICES = 'GET_HOTEL_PRICES';
export const GET_META = 'GET_META';
export const CHANGE_PAGE_COUNT = 'CHANGE_PAGE_COUNT';
export const CHANGE_PULLUP_LOADING = 'CHANGE_PULLUP_LOADING';
export const CHANGE_LOADING = 'CHANGE_LOADING';
export const CHANGE_ALL_LOADING = 'CHANGE_ALL_LOADING';
export const CHANGE_FORWARD_AREA_ID = 'CHANGE_FORWARD_AREA_ID';
export const CHANGE_SCROLLY = 'CHANGE_SCROLLY';
export const PERPAGE = 15;